import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { environment } from '../environments/environment';
// import { ApiRequest } from '../ApiRequest';

@Injectable()
export class AppInfoService {

  // authapibaseurl : string = environment.BackendApi;

  // constructor(private _httpClient : HttpClient)
  // {


  // }

  public get title() {
    return 'Easyportal';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }

  // getBatches(apiReq: ApiRequest)
  // {
  //   return this._httpClient.get(`${this.authapibaseurl}/batch/get`);
  // }

  // getAllBatches()
  // {
  //   return this._httpClient.get(`${this.authapibaseurl}/batch/get`);
  // }

}
